import { render, staticRenderFns } from "./ImportEvro.vue?vue&type=template&id=3b20bcd7"
import script from "./ImportEvro.vue?vue&type=script&lang=js"
export * from "./ImportEvro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports